var map = {
	"./cosmos.svg": 40895,
	"./erc20.svg": 58143,
	"./kusama.svg": 80605,
	"./near.svg": 15021,
	"./polkadot.svg": 91529,
	"./solana.svg": 70427,
	"./walletconnect.svg": 74990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83201;